import { render, staticRenderFns } from "./AllDepartments.vue?vue&type=template&id=59e7dd34"
import script from "./AllDepartments.vue?vue&type=script&lang=js"
export * from "./AllDepartments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports